import { render, staticRenderFns } from "./_record.vue?vue&type=template&id=a6543524&scoped=true&"
import script from "./_record.vue?vue&type=script&lang=js&"
export * from "./_record.vue?vue&type=script&lang=js&"
import style0 from "./_record.vue?vue&type=style&index=0&id=a6543524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6543524",
  null
  
)

export default component.exports